import React from 'react';

type VersionedTextProps = {
  versionedText: Object,
  replacements: { [key: string]: string }
}

const VersionedText = (versionedText, replacements = {}): VersionedTextProps => {
  const flatMap = [];

  let displayText = versionedText.display_text;

  // Use a regular expression to find {{key}} patterns in the string
  displayText.replace(/{{([A-Za-z _]+)}}/g, (match, key) => {
    displayText = displayText.split(match);
    flatMap.push(<span>{displayText[0]}</span>);
    displayText = displayText[1];

    if (replacements[key]) {
      flatMap.push(<span>{replacements[key]}</span>);
      return replacements[key];
    }
    if (versionedText.replacements) {
      const replacement = versionedText.replacements.find((r) => r.key === key);
      if (replacement) {
        if (replacement.type === 'link') {
          return flatMap.push(<a href={replacement.value} className='type-link'>{key}</a>);
        }

        return replacement.value;
      }
    }

    return match;
  });

  return <span>{flatMap}</span>;
};

export default VersionedText;



// WEBPACK FOOTER //
// ./src/components/shared/VersionedText.js